import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
import { useEffect, useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography } from '@mui/material';
import { getCategoryCounts, getMonthlyPostCounts, getTotalPostsByStatus, profileAdmin } from '../api/service';
// components
import Iconify from '../components/iconify';
// sections
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const theme = useTheme();

  const token = localStorage.getItem('token');
  const [postStats, setPostStats] = useState();
  const [issueChartData, setIssueChartData] = useState();
  const [postsHistogram, setPostsHistogram] = useState();

  const getPostDetails = async () => {
    console.log(token);
    getTotalPostsByStatus(token)
      .then((res) => {
        setPostStats(res.data);
        console.log(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getIssueChartData = async () => {
    console.log(token);
    getCategoryCounts(token)
      .then((res) => {
        setIssueChartData(res.data);
        console.log(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getPostHistogramData = async () => {
    getMonthlyPostCounts(token)
      .then((res) => {
        setPostsHistogram(res.data);
        console.log(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getPostDetails();
    getIssueChartData();
    getPostHistogramData();
  }, []);

  return (
    <>
      <Helmet>
        <title> Mumbai Dashboard | Jal Suraकsha </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          {/* Jal Suraksha Stats (Mumbai) */}
          <span className="inline-block">
            JAL SURA
            <span style={{ color: 'red' }}>क</span>
            SHA STATS (MUMBAI)
          </span>
        </Typography>

        <Grid container spacing={3}>
          {postStats && (
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Total Posts Created"
                color="secondary"
                total={postStats.totalPosts !== 0 ? postStats.totalPosts : '0'}
                icon={'mdi:post-it-note-edit'}
              />
            </Grid>
          )}

          {postStats && (
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Issues Initiated"
                total={postStats.openIssues !== 0 ? postStats.openIssues : '0'}
                color="info"
                icon={'fa6-solid:hourglass-start'}
              />
            </Grid>
          )}

          {postStats && (
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Issues In-Progress"
                total={postStats.inProgressIssues !== 0 ? postStats.inProgressIssues : '0'}
                color="warning"
                icon={'carbon:progress-bar-round'}
              />
            </Grid>
          )}

          {postStats && (
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Issues Solved"
                total={postStats.closedIssues !== 0 ? postStats.closedIssues : '0'}
                color="success"
                icon={'fluent-mdl2:completed-solid'}
              />
            </Grid>
          )}

          {postsHistogram && (
            <Grid item xs={12} md={6} lg={8}>
              <AppWebsiteVisits
                title="Posts"
                subheader="(+43%) than last month"
                chartLabels={postsHistogram.chartLabels}
                chartData={postsHistogram.chartData}
              />
            </Grid>
          )}

          {issueChartData && (
            <Grid item xs={12} md={6} lg={4}>
              <AppCurrentVisits
                title="Problems Faced"
                chartData={issueChartData.chartData}
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.info.main,
                  theme.palette.warning.main,
                  theme.palette.error.main,
                ]}
              />
            </Grid>
          )}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates
              title="Conversion Rates"
              subheader="(+43%) than last year"
              chartData={[
                { label: 'Italy', value: 400 },
                { label: 'Japan', value: 430 },
                { label: 'China', value: 448 },
                { label: 'Canada', value: 470 },
                { label: 'France', value: 540 },
                { label: 'Germany', value: 580 },
                { label: 'South Korea', value: 690 },
                { label: 'Netherlands', value: 1100 },
                { label: 'United States', value: 1200 },
                { label: 'United Kingdom', value: 1380 },
              ]}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject
              title="Current Subject"
              chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
              chartData={[
                { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
                { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
                { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
              ]}
              chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
            />
          </Grid> */}

          <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate
              title="News Update"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: faker.name.jobTitle(),
                description: faker.name.jobTitle(),
                image: `/assets/images/covers/cover_${index + 1}.jpg`,
                postedAt: faker.date.recent(),
              }))}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Issue Solving Stages"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  'Issue Fetched',
                  'Issue Registered and Initiated',
                  'Work In-Progress',
                  'Solved',
                  'Request Rejected',
                ][index],
                type: `order${index + 1}`,
              }))}
            />
          </Grid>

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite
              title="Traffic by Site"
              list={[
                {
                  name: 'FaceBook',
                  value: 323234,
                  icon: <Iconify icon={'eva:facebook-fill'} color="#1877F2" width={32} />,
                },
                {
                  name: 'Google',
                  value: 341212,
                  icon: <Iconify icon={'eva:google-fill'} color="#DF3E30" width={32} />,
                },
                {
                  name: 'Linkedin',
                  value: 411213,
                  icon: <Iconify icon={'eva:linkedin-fill'} color="#006097" width={32} />,
                },
                {
                  name: 'Twitter',
                  value: 443232,
                  icon: <Iconify icon={'eva:twitter-fill'} color="#1C9CEA" width={32} />,
                },
              ]}
            />
          </Grid> */}
          {/* 
          <Grid item xs={12} md={6} lg={8}>
            <AppTasks
              title="Tasks"
              list={[
                { id: '1', label: 'Create FireStone Logo' },
                { id: '2', label: 'Add SCSS and JS files if required' },
                { id: '3', label: 'Stakeholder Meeting' },
                { id: '4', label: 'Scoping & Estimations' },
                { id: '5', label: 'Sprint Showcase' },
              ]}
            />
          </Grid> */}
        </Grid>
      </Container>
    </>
  );
}
